var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpcomingEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 41.3429V45.0229C84.9951 53.6486 82.202 62.0416 77.0373 68.9502C71.8727 75.8588 64.6131 80.9128 56.3414 83.3585C48.0697 85.8042 39.229 85.5105 31.1379 82.5212C23.0467 79.5319 16.1386 74.0073 11.4438 66.7711C6.74906 59.535 4.51916 50.9751 5.08671 42.3681C5.65425 33.7611 8.98883 25.5682 14.5931 19.0112C20.1974 12.4542 27.7711 7.88442 36.1847 5.98348C44.5984 4.08253 53.4011 4.95224 61.28 8.4629M85 13.0229L45 53.0629L33 41.0629",
    stroke: "#EEF7FE",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingEmptyState);
export default "data:image/svg+xml,%3csvg width='90' height='90' viewBox='0 0 90 90' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M85 41.3429V45.0229C84.9951 53.6486 82.202 62.0416 77.0373 68.9502C71.8727 75.8588 64.6131 80.9128 56.3414 83.3585C48.0697 85.8042 39.229 85.5105 31.1379 82.5212C23.0467 79.5319 16.1386 74.0073 11.4438 66.7711C6.74906 59.535 4.51916 50.9751 5.08671 42.3681C5.65425 33.7611 8.98883 25.5682 14.5931 19.0112C20.1974 12.4542 27.7711 7.88442 36.1847 5.98348C44.5984 4.08253 53.4011 4.95224 61.28 8.4629M85 13.0229L45 53.0629L33 41.0629' stroke='%23EEF7FE' stroke-width='10' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };